// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/js/async/" + ({"354": "lib-axios","535": "lib-router","783": "lib-react",}[chunkId] || chunkId) + "." + {"116": "bbfec617","122": "21a578a4","354": "9c6094ad","486": "a55a7856","489": "02fb0539","535": "60d1c9bc","783": "40d61eba",}[chunkId] + ".js"
}